import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/donatii/DonationForm.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/donatii/QrCodeSection.tsx")